import * as yup from 'yup';
const planOffersSchema = yup
    .object()
    .shape({
    plan_offers: yup.string().required('Plan offer is required')
})
    .defined();
export default planOffersSchema;
